/* batida-gate.js (8.10.2026, Horizon P1): the deferred part of the city / postcode gate of batida.pl. Moved out of the two big
   inline scripts of the live header (snippets/zip-cookies.liquid + zip-code-validator.liquid @ b2c-redesign 3bad9e8) without
   changing what they do. The small inline part (cookie helpers, zone, pill labels, showFullOffer, dismissLocationModal, the
   batida_* dataLayer events) is snippets/batida-gate-core.liquid and runs while the page is parsed, as live.
   Here: the Connect postcode lookup (4 s deadline, then the zone lists of sections/batida-zone-data), the postcode check and
   submit, "opens by itself" rules per page type, the dialog (open / close / focus trap / Esc), the in-dialog language pills,
   the wait for Shopify's cookie banner (BS-31), the localized dialog strings, the header chip text.
   Cookies: zip_cookie, city_cookie, batida_zone (365 days) - semantics unchanged. Events: batida_location_gate_open /
   _gate_open_click / _result / _dismiss - unchanged (pushed to dataLayer + Shopify.analytics). */
(function () {
  'use strict';
  if (window.__batidaGateJs) return;
  window.__batidaGateJs = true;

  var modal = document.getElementById('myModal');
  var T = (modal && modal.dataset) || {};

  /* ---------- zone lookup (live zip-cookies, "Zone gate 2026-09-24" / 30.09 Pat) ---------- */
  /* Resolves "W" (Warsaw delivery), "D" (DPD city) or "X" (no delivery). The answer comes from Batida Connect's postcode check - the
     same zones the checkout charges by. Only if Connect doesn't answer within 4 s, the old lists are used (fetched once from
     sections/batida-zone-data). */
  window.batidaZoneLookup = function (zip) {
    if (zip === '00-001') return Promise.resolve('W');
    var api = (window.BatidaConnect && window.BatidaConnect.api) || '/apps/connect/';
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;
    return fetch(api + 'postcode?code=' + encodeURIComponent(zip), { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('connect ' + r.status); return r.json(); })
      .then(function (d) { if (timer) clearTimeout(timer); if (!d || !d.valid) throw new Error('connect invalid'); return d.delivery ? 'W' : d.shipping ? 'D' : 'X'; })
      .catch(function () { if (timer) clearTimeout(timer); return zoneLookupLists(zip); });
  };
  function zoneLookupLists(zip) {
    if (!window.__batidaZoneData) {
      var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
      window.__batidaZoneData = fetch(root + '?section_id=batida-zone-data', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('zone data ' + r.status); return r.text(); })
        .then(function (html) {
          var m = html.match(/<script[^>]*id="batida-zone-data"[^>]*>([\s\S]*?)<\/script>/);
          var d = JSON.parse(m[1]), map = {};
          (d.W || '').split(/[^0-9-]+/).forEach(function (z) { if (z) map[z] = 'W'; });
          (d.D || '').split(/[^0-9-]+/).forEach(function (z) { if (z && !map[z]) map[z] = 'D'; });
          return map;
        })
        .catch(function (e) { window.__batidaZoneData = null; throw e; });
    }
    return window.__batidaZoneData.then(function (map) { return map[zip] || 'X'; });
  }
  /* "?" zone = a postcode typed before the zone cookie existed: resolve once in the background, reload only if it is not Warsaw */
  if (window.batidaZone === '?') {
    window.batidaZoneLookup(getCookie('zip_cookie')).then(function (z) {
      setCookie('batida_zone', z, 365);
      if (z !== 'W') window.location.reload();
    }, function () {});
  }

  /* ---------- postcode check + submit (live zip-cookies) ---------- */
  function validateZipCode(zipCode) { return /^\d{2}-\d{3}$/.test(zipCode); }
  /* Returns a Promise: "W" / "D" when the postcode gets delivery (cookies set), false otherwise. Called on blur and on submit. */
  window.__batidaCheckZip = function () {
    var zipCodeInput = document.getElementById('zipCode');
    if (!zipCodeInput) return Promise.resolve(false);
    /* 29.09 (Dominika): phone number pads have no "-": accept 01246 as well as 01-246 and show it as 01-246. */
    var zipDigits = zipCodeInput.value.replace(/\D/g, '');
    var zipCode = zipDigits.length === 5 ? zipDigits.slice(0, 2) + '-' + zipDigits.slice(2) : zipCodeInput.value.trim();
    if (zipCode !== zipCodeInput.value) zipCodeInput.value = zipCode;
    var errorSpan = document.getElementById('zipCodeError');
    if (!validateZipCode(zipCode)) { if (errorSpan) errorSpan.textContent = T.tPostcodeError || ''; zipCodeInput.classList.add('error'); return Promise.resolve(false); }
    function eligible(zone) {
      var na = document.querySelector('.notavailable_code'), av = document.querySelector('.available_code'), fb = document.getElementById('fulloffer_btn');
      if (na) na.style.display = 'none'; if (av) av.style.display = 'block'; if (fb) fb.textContent = T.tFulloffer || fb.textContent; var fd = document.querySelector('.fulloffer_btn_div'); if (fd) fd.style.display = 'none';
      var nm = document.querySelector('[data-zip-nocode-more]'); if (nm) nm.style.display = 'none';
      setCookie('zip_cookie', zipCode, 365); deleteCookie('city_cookie');
      if (zone) setCookie('batida_zone', zone, 365); else deleteCookie('batida_zone');
      if (typeof hide_all_products !== 'undefined') hide_all_products = false;
      if (errorSpan) errorSpan.textContent = ''; zipCodeInput.classList.remove('error');
    }
    return window.batidaZoneLookup(zipCode).then(function (zone) {
      if (zone === 'W' || zone === 'D') {
        eligible(zone);
        batidaTrackGate('location_result', { result: 'eligible', zone: (zone === 'W' ? 'group_a' : 'group_b') });
        return zone;
      }
      var na = document.querySelector('.notavailable_code'), av = document.querySelector('.available_code'), fb = document.getElementById('fulloffer_btn');
      if (na) na.style.display = 'block'; if (av) av.style.display = 'none'; if (fb) fb.textContent = T.tNocode || fb.textContent; var fd = document.querySelector('.fulloffer_btn_div'); if (fd) fd.style.display = 'block';
      var nm = document.querySelector('[data-zip-nocode-more]'); if (nm) nm.style.display = 'block';   // 11.10: next steps, not a dead end
      batidaTrackGate('location_result', { result: 'ineligible', zone: 'out_of_zone' });
      return false;
    }, function () {
      /* the zone lists could not be loaded: keep the postcode without a zone and show the full offer; the next page resolves it again ("?") */
      eligible(null);
      return 'W';
    });
  };
  /* BS-94 (2026-06-07): postcode SUBMIT path. A DPD-city postcode goes straight to the nationwide-delivery collection, a Warsaw
     postcode keeps the native form submit. The lookup is asynchronous, so the submit is always held and sent again by hand. */
  window.__batidaValidateForm = function () {
    var form = document.getElementById('myForm');
    window.__batidaCheckZip().then(function (zone) {
      if (!zone) return;
      if (zone === 'D') {
        var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
        window.location.href = root + '/collections/wysylka-w-polske';
        return;
      }
      if (form) HTMLFormElement.prototype.submit.call(form); else window.location.reload();
    });
    return false;
  };

  /* ---------- when the gate opens by itself (live zip-cookies __batidaGateAuto, Clarity 1 / 6a, Aleksandra 5.10 / 6.10) ---------- */
  /* home, collections, product pages: never by itself (the header chip opens it). Elsewhere: after the visitor's first click on the
     page (a click on a link opens it on the next page, a click on a button / field / the cookie banner waits for the next one),
     only once per browser (localStorage batida_gate_seen), never on top of the cookie banner, in a smaller version (v7-zip--compact). */
  window.__batidaGateAuto = function (m) {
    if (!m) return;
    if (!document.documentElement.classList.contains('v7')) { m.style.display = 'block'; return; }
    var tpl = window.__batidaGateTpl;
    if (tpl === 'product') return;
    /* 11.10 (Pat, Clarity day 1): never by itself on the cart - the cart asks for pickup / delivery and the postcode itself, and the
       pop-up opened over the half-filled form at the customer's first click there (a choice in it reloads the cart: /en/cart?zipCode=) */
    if (tpl === 'cart') return;
    if (tpl === 'index' || tpl === 'collection' || tpl === 'list-collections') {
      try { sessionStorage.removeItem('batida_gate_next'); } catch (e) {}
      return;
    }
    var KEY = 'batida_gate_seen';
    try { if (localStorage.getItem(KEY) === '1') return; } catch (e) {}
    function bannerUp() {
      var els = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs');
      for (var i = 0; i < els.length; i++) {
        var cs = getComputedStyle(els[i]), r = els[i].getBoundingClientRect();
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) !== 0 && r.width > 0 && r.height > 0) return true;
      }
      return false;
    }
    var tries = 0;
    function openSmall() {
      if (getCookie('zip_cookie') !== '' || getCookie('city_cookie') !== '') return;
      if (m.style.display === 'block') return;
      if (bannerUp() && tries++ < 150) { setTimeout(openSmall, 400); return; }
      try { localStorage.setItem(KEY, '1'); sessionStorage.removeItem('batida_gate_next'); } catch (e) {}
      m.classList.add('v7-zip--compact');
      m.style.display = 'block';
      batidaTrackGate('location_gate_open_click', {});
    }
    document.querySelectorAll('#myBtn, .batida-loc-btn').forEach(function (b) {
      b.addEventListener('click', function () { m.classList.remove('v7-zip--compact'); }, true);
    });
    var next = false;
    try { next = sessionStorage.getItem('batida_gate_next') === '1'; } catch (e) {}
    if (next) { setTimeout(openSmall, 700); return; }
    function onFirstClick(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#myModal, #shopify-pc__banner, #shopify-pc__prefs, #myBtn, .batida-loc-btn')) return;
      var a = t.closest('a[href]');
      if (a) {
        var h = a.getAttribute('href') || '';
        if (h.charAt(0) !== '#' && h.indexOf('javascript:') !== 0 && a.target !== '_blank') {
          document.removeEventListener('click', onFirstClick, true);
          try { sessionStorage.setItem('batida_gate_next', '1'); } catch (er) {}
        }
        return;
      }
      if (t.closest('button, input, select, textarea, label, summary, [role="button"], [data-drawer-toggle]')) return;
      document.removeEventListener('click', onFirstClick, true);
      setTimeout(openSmall, 300);
    }
    document.addEventListener('click', onFirstClick, true);
  };

  /* ---------- the dialog (live zip-code-validator) ---------- */
  /* v59 / BS-216: localize the strings that live in theme settings (Polish) for the other languages; PL: nothing to do */
  (function localizeStrings() {
    var STR = {
      'zip_modal.heading': { en: 'Welcome!', de: 'Willkommen!', fr: 'Bienvenue !', uk: 'Вітаємо!' },
      'zip_modal.nocode_heading': { en: "We don't deliver there yet", de: 'Dort liefern wir leider noch nicht', fr: 'Nous ne livrons pas encore ici', uk: 'На жаль, ми ще не доставляємо сюди' },
      'zip_modal.nocode_subheading': { en: "No delivery for this postcode yet — we're working on it", de: 'Für diese Postleitzahl gibt es noch keine Lieferung — wir arbeiten daran', fr: 'Pas encore de livraison pour ce code postal — on y travaille', uk: 'Для цього індексу доставки ще немає — ми працюємо над цим' },
      'zip_modal.fulloffer_btn': { en: 'Pick up in store (full range)', de: 'Abholung im Geschäft (ganzes Sortiment)', fr: "Retrait en boutique (toute l'offre)", uk: 'Самовивіз (повний асортимент)' }
    };
    var lang = (document.documentElement.lang || 'pl').toLowerCase().split('-')[0];
    Object.keys(STR).forEach(function (key) {
      var node = document.querySelector('[data-batida-i18n-key="' + key + '"]');
      if (node && STR[key][lang]) node.textContent = STR[key][lang];
    });
  })();

  function disableScroll() { document.body.style.overflow = 'hidden'; }
  function enableScroll() { document.body.style.overflow = ''; }
  function isThemeEditor() { return (typeof Shopify !== 'undefined' && Shopify.designMode === true); }
  function closeModalForEditor() { if (modal) modal.style.display = 'none'; enableScroll(); }

  if (modal) {
    var zipClose = modal.querySelector('.close');
    var resetBtn = modal.querySelector('.resetBtn');
    if (resetBtn) {
      resetBtn.onclick = function () {
        deleteCookie('zip_cookie'); deleteCookie('city_cookie'); deleteCookie('batida_zone');
        window.location.reload();
      };
    }
    /* the header chips (.batida-loc-btn, phone + desktop + phone menu) open it; an explicit click always wins over the consent deferral below */
    document.querySelectorAll('#myBtn, .batida-loc-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        window.__batidaGateUserOpened = true;
        modal.style.display = 'block';
        disableScroll();
      });
    });
    /* in the theme editor reload / Set-Cookie do not survive the preview iframe: just hide the pop-up locally */
    if (zipClose) {
      zipClose.onclick = function () {
        if (isThemeEditor()) { closeModalForEditor(); return; }
        window.dismissLocationModal();   /* dismiss without choosing: the catalogue stays open, the header reads "wybierz" */
      };
    }
    window.onclick = function (event) {
      if (event.target == modal) {
        if (isThemeEditor()) { closeModalForEditor(); return; }
        window.dismissLocationModal();   /* the dimmed backdrop = the X */
      }
    };
    if (isThemeEditor()) {
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.style.display === 'block') closeModalForEditor(); });
    }
    var zipCodeInput = document.getElementById('zipCode');
    if (zipCodeInput) zipCodeInput.addEventListener('blur', window.__batidaCheckZip);
    /* 11.10 (Pat, Clarity day 1): "Spróbuj inny kod" under the out-of-zone message - back to the postcode field, emptied and focused */
    var retry = modal.querySelector('[data-zip-retry]');
    if (retry) retry.addEventListener('click', function () {
      var na = modal.querySelector('.notavailable_code'), av = modal.querySelector('.available_code'), fd = modal.querySelector('.fulloffer_btn_div'), nm = modal.querySelector('[data-zip-nocode-more]');
      if (na) na.style.display = 'none'; if (av) av.style.display = 'block'; if (fd) fd.style.display = 'none'; if (nm) nm.style.display = 'none';
      var zi = document.getElementById('zipCode'); if (zi) { zi.value = ''; zi.classList.remove('error'); try { zi.focus(); } catch (e) {} }
      batidaTrackGate('location_retry', {});
    });

    /* city buttons: city_cookie + zip_cookie + batida_zone, then reload (Warszawa) or go to the nationwide delivery collection (DPD cities, BS-94) */
    modal.querySelectorAll('.city-btn').forEach(function (cityBtn) {
      cityBtn.addEventListener('click', function () {
        var cityName = this.getAttribute('data-city-name');
        var cityZip = this.getAttribute('data-city-zip');
        var redirectTo = null;
        if (cityName !== 'Warszawa') {
          var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
          redirectTo = root + '/collections/wysylka-w-polske';
        }
        window.setCityCookie(cityName, cityZip, redirectTo);
      });
    });
    /* v59 / BS-60: in-dialog language pills: remember the choice and re-open the dialog on the reloaded page */
    modal.querySelectorAll('[data-batida-set-locale]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        try { localStorage.setItem('batida_locale_chosen', '1'); } catch (e) {}
        try { sessionStorage.setItem('batida_reopen_locmodal', '1'); } catch (e) {}
      });
    });
    /* BS-60: reopen after a language-pill reload (registered after the inline DOMContentLoaded handler, so it runs last and wins) */
    document.addEventListener('DOMContentLoaded', function () {
      var reopen = null;
      try { reopen = sessionStorage.getItem('batida_reopen_locmodal'); } catch (e) {}
      if (reopen === '1') {
        try { sessionStorage.removeItem('batida_reopen_locmodal'); } catch (e) {}
        modal.style.display = 'block'; disableScroll();
      }
    });

    /* BS-31 (2026-08-31): keep the gate out from under Shopify's cookie banner (#shopify-pc__banner, injected after DOMContentLoaded at
       z-index 2000000). Hold the gate while the banner is on its way or on screen; open it once the banner is out of the way.
       The DOM decides when the banner is gone (shouldShowBanner() only as the "is one coming" hint); the watcher keeps running
       after the 8 s backstop so a late banner still gets a clear screen. */
    (function deferGateBehindConsent() {
      var CONSENT_SEL = '#shopify-pc__banner, #shopify-pc__prefs';
      var APPEAR_WATCH_MS = 8000, MAX_WATCH_MS = 30000, TICK_MS = 200;
      function bannerOnScreen() {
        var els = document.querySelectorAll(CONSENT_SEL);
        for (var i = 0; i < els.length; i++) {
          var el = els[i], cs = getComputedStyle(el);
          if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
          var r = el.getBoundingClientRect();
          if (r.width < 1 || r.height < 1) continue;
          return true;
        }
        return false;
      }
      function bannerExpected() {
        try {
          if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.shouldShowBanner === 'function') return Shopify.customerPrivacy.shouldShowBanner() === true;
        } catch (e) {}
        return null;
      }
      function stillUnchosen() { try { return getCookie('zip_cookie') === '' && getCookie('city_cookie') === ''; } catch (e) { return true; } }
      function openGate() { if (modal.style.display === 'block') return; if (!stillUnchosen()) return; modal.style.display = 'block'; }
      function hideGate() { modal.style.display = 'none'; }
      function standDown() { return !!window.__batidaGateUserOpened || !stillUnchosen(); }
      document.addEventListener('DOMContentLoaded', function () {
        if (isThemeEditor()) return;
        if (modal.style.display !== 'block') return;
        if (!stillUnchosen()) return;
        var expected = bannerExpected();
        if (expected === false) return;
        var sawBanner = bannerOnScreen();
        if (sawBanner || expected === true) hideGate();
        var openedByBackstop = false;
        var backstopAt = Date.now() + APPEAR_WATCH_MS, stopAt = Date.now() + MAX_WATCH_MS;
        var iv = setInterval(function () {
          if (standDown()) { clearInterval(iv); return; }
          if (bannerOnScreen()) { sawBanner = true; openedByBackstop = false; hideGate(); return; }
          if (sawBanner) { clearInterval(iv); openGate(); return; }
          if (!openedByBackstop && Date.now() > backstopAt) { openedByBackstop = true; openGate(); }
          if (Date.now() > stopAt) { clearInterval(iv); openGate(); }
        }, TICK_MS);
      });
    })();

    /* BS-28 (2026-06-02): dialog accessibility - focus into the dialog on open, Tab trap, Esc = the X, focus back to the opener */
    (function () {
      var dialog = modal.querySelector('.modal-content') || modal;
      var opener = null;
      var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
      function focusables() {
        return Array.prototype.filter.call(dialog.querySelectorAll(SEL), function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; });
      }
      function restoreFocus() { if (opener && typeof opener.focus === 'function') { try { opener.focus(); } catch (e) {} } opener = null; }
      function onKeydown(e) {
        if (modal.style.display !== 'block') return;
        if (e.key === 'Escape' || e.keyCode === 27) {
          e.preventDefault();
          if (isThemeEditor()) { modal.style.display = 'none'; document.body.style.overflow = ''; restoreFocus(); }
          else if (typeof window.dismissLocationModal === 'function') { window.dismissLocationModal(); }
          return;
        }
        if (e.key === 'Tab' || e.keyCode === 9) {
          var f = focusables();
          if (!f.length) { e.preventDefault(); try { dialog.focus(); } catch (er) {} return; }
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      function onOpen() {
        opener = document.activeElement;
        document.addEventListener('keydown', onKeydown, true);
        if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
        setTimeout(function () { try { dialog.focus(); } catch (e) {} }, 30);
      }
      function onClose() { document.removeEventListener('keydown', onKeydown, true); restoreFocus(); }
      var wasOpen = (modal.style.display === 'block');
      if (wasOpen) onOpen();
      try {
        new MutationObserver(function () {
          var open = (modal.style.display === 'block');
          if (open && !wasOpen) onOpen(); else if (!open && wasOpen) onClose();
          wasOpen = open;
        }).observe(modal, { attributes: true, attributeFilter: ['style'] });
      } catch (e) {}
    })();
  }

  /* v7 (28.09): the header chip "Lokalizacja: ..." - runs after the pill labels are set: "wybierz" (skipped) / nothing -> "wybierz miasto",
     "Odbiór" -> "odbiór w cukierni", a city or a typed postcode stays. Also puts the visitor's zone on <html> for the card greying CSS. */
  document.addEventListener('DOMContentLoaded', function () {
    function gc(n) { var m = ('; ' + document.cookie).split('; ' + n + '='); if (m.length < 2) return ''; var v = m.pop().split(';').shift(); try { return decodeURIComponent(v); } catch (e) { return v; } }
    var raw = gc('city_cookie') || gc('zip_cookie');
    document.querySelectorAll('.v7-loc .default_code').forEach(function (el) {
      var t = raw;
      if (!raw || raw === 'wybierz') t = el.getAttribute('data-v7-empty');
      else if (raw === 'Odbiór') t = el.getAttribute('data-v7-pickup');
      el.textContent = t;
      el.closest('.v7-loc').classList.toggle('is-set', !!raw && raw !== 'wybierz');
    });
    /* 2.10 (Pat): in the popup only the city the visitor picked is marked (none before a choice) */
    var city = gc('city_cookie');
    document.querySelectorAll('#myModal .city-btn').forEach(function (b) { b.classList.toggle('is-current', !!city && b.getAttribute('data-city-name') === city); });
    document.querySelectorAll('#myModal .v7-zip__pickup').forEach(function (b) { b.classList.toggle('is-current', city === 'Odbiór'); });
    document.documentElement.setAttribute('data-batida-zone', window.batidaZone || '');
  });
})();
